const config = {
    build_number: '615267',
    build_timestamp: '2026-08-10T19:57:31.850Z',
    build_commit: '8c3981a1a0d4838ba81b433f486b9ccb3a636975',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
